var render, staticRenderFns
import script from "./TransitionExpanded.vue?vue&type=script&lang=js"
export * from "./TransitionExpanded.vue?vue&type=script&lang=js"
import style0 from "./TransitionExpanded.vue?vue&type=style&index=0&id=3295d722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295d722",
  null
  
)

export default component.exports